module.exports = __webpack_public_path__ + "img/3.c06b8ed4.jpg";